<template>
  <div id="investor_556" style="position: relative">
    <div class="iconfont icon-fangda" @click="show_chart_dialog = !show_chart_dialog"></div>
    <div style="display: flex; align-items: center; margin-top: 16px">
      <CSelect
        @CSelect_select_val="fnCSelect_chart11"
        :multiple="false"
        :clearable="false"
        mini
        v-bind.sync="select11"
        >选择报告期</CSelect
      >
      <CSelect
        style="margin-left: 16px"
        @CSelect_select_val="fnCSelect_chart1"
        :multiple="false"
        :clearable="false"
        auto
        v-bind.sync="select1"
        >选择资金类型</CSelect
      >
      <CCascader
        style="margin-left: 16px"
        @CCascader_select_node="fnCCascader_select_val_chart3"
        :default="da_lei_default_value"
        :checkStrictly="true"
        :multiple="true"
        :collapsetags="true"
        :options="category_cascader_options"
        >选择类别
      </CCascader>
      <CCascader
        style="margin-left: 16px"
        :checkStrictly="false"
        :multiple="true"
        :isDelete="false"
        :default="reit_code_default"
        placeholder="请选择个股"
        :collapsetags="true"
        @CCascader_select_val="fnSelect_select_val_chart1_codename"
        :options="CODENAMEDATA">
        选择对比REITs
      </CCascader>
      <div style="margin-left: auto; margin-right: 0">
        <Download
          :dButtonsDownloads="dButtonsDownloads"
          :excel_info="excel_info1"
          echartRefName="chart_5425" />
      </div>
    </div>
    <div style="display: flex; margin-top: 16px">
      <CButtons
        style="margin-left: 0"
        :dButtons1="select_4"
        :dButtons1_current="select_4_default"
        @Cbtns_sep="select4Change" />
    </div>
    <div style="display: flex; margin-top: 16px">
      <div style="display: flex; margin-left: 16px; margin-top: 4px; align-items: center">
        <el-radio v-model="gb" label="object_type">机构大类对比</el-radio>
        <el-radio v-model="gb" label="object_name">具体机构</el-radio>
      </div>
      <div style="display: flex; margin-left: 16px; margin-top: 4px; align-items: center">
        <el-radio v-model="show_cate" label="category_1">大类</el-radio>
        <el-radio v-model="show_cate" label="category_2">细分</el-radio>
        <el-radio v-model="show_cate" label="reit_code">个股</el-radio>
      </div>
      <div
        style="display: flex; margin-left: 16px; align-items: center"
        :class="{ hidden: gb !== 'object_name' }">
        最大显示个数<input v-model="range" class="input-range" />
      </div>
      <CSelect
        :class="{ hidden: gb !== 'object_name' }"
        style="margin-left: 16px"
        @CSelect_select_val="fnCSelect_chart3"
        multiple
        :clearable="false"
        wide
        v-bind.sync="select3"
        >筛选机构大类</CSelect
      >
    </div>
    <div style="margin-top: 16px; display: flex; align-items: center">
      <CButtons
        v-if="select_4_default != '本期与上期对比'"
        style="margin-left: 0"
        :dButtons1="select_2"
        :dButtons1_current="select_2_default"
        @Cbtns_sep="select2Change" />
      <CButtons
        v-else
        style="margin-left: 0"
        :dButtons1="select_2_2"
        :dButtons1_current="select_2_2_default"
        @Cbtns_sep="select2Change" />
      <span class="oneyear" v-if="select_4_default == '本期与上期对比'">
        <el-checkbox v-model="del_new_code"></el-checkbox>
        剔除新券
      </span>
      <span class="oneyear" v-if="select_4_default == '本期与上期对比'">
        <el-checkbox v-model="del_gujiafuyin"></el-checkbox>
        剔除期间基金单位价格浮盈/浮亏
      </span>
      <el-tooltip
        class="item"
        effect="dark"
        content=""
        placement="top"
        v-if="select_4_default == '本期与上期对比'">
        <div slot="content">
          剔除基金单位价格浮盈/浮亏<br />
          【指标定义】<br />
          基金单位价格浮盈/浮亏是指持有同样基金单位情况下，在2个财报期之间由于价格升高或下降，造成的持仓金额增加<br />
          或减少，但其实实际的投资者可能持有基金单位并没有变化，只是由于价格导致的浮盈/浮亏。剔除方法：均采用本期<br />
          对应最后一个交易日的收盘价与不同时间的基金单位相乘，来剔除价格影响；<br />
          【优劣势建议】<br />
          剔除的好处：可以更直观的了解对应调仓部分的考虑；但可能虽然反应了调仓的动作，但是和目前投资人实际的持有<br />
          市值不契合；<br />
          不剔除的好处：由于最终投资者的仓位金额与这个财报期的收盘价相同，更加接近目前持仓的真实市值，<br />
          因此可以更清楚的看到投资人实际个券暴露的综合考虑；<br />
          【计算方式及示例】<br />
          A投资者，在2025H1的前十大披露口径中持有1.2亿份基金单位的，本报告期3.012元/基金单位的某REIT，在2024A<br />
          该投资人持有1.4亿份，对应2024年12月31日的价格为2.605元/基金单位<br />
          剔除情况下：<br />
          差异金额 = 本期价格*本期该投资者持有的基金单位 – 本期价格 *本期该投资者持有的基金单位<br />
          差异金额 = 1.2亿份*3.012元/份 – 1.4亿份*3.012元/份 = -0.6024 亿元<br />
          不剔除情况下：<br />
          差异金额 = 本期价格*本期该投资者持有的基金单位 – 上期价格 *本期该投资者持有的基金单位
          <br />
          差异金额 = 1.2亿份*3.012元/份 – 1.4亿份* 2.605元/份 = 0.2474 亿元
          <br />
          基金单位价格浮盈0.2474- (-0.6024 )=  0.8498亿元
          <br />
          因此看到，这个A投资者，在2个财报的期间的持仓分为了2部分，通过减持减少了0.6024亿元的仓位，同时由于基金<br />
          单位浮盈得到了0.8498亿元，经过这样的变化后，虽然A减持了，但其实A持有某REIT的市值增加了，A投资者最终的<br />
          仓位变成了目前的位置；这个过程很有可能是因为期间股价涨幅较高，才带来了A的减持，采用剔除可以看到A的操作，<br />
          采用不剔除可以看到A的综合考虑仍然采用了对于某REIT更高的市值暴露；
        </div>
        <i class="el-icon-question" style="color: rgb(64, 158, 255)"></i>
      </el-tooltip>
      <span class="oneyear">
        <el-checkbox v-model="get_real_holder"></el-checkbox>
        持有者穿透
      </span>
      <el-tooltip class="item" effect="dark" content="" placement="top">
        <div slot="content">
          持有者穿透说明
          <br />
          【指标定义】
          <br />
          根据在CREITS财报中披露的持有人的名字进行一定程度真实持有人的穿
          <br />
          透，但本系统仅可根据公开信息进行穿透，无法对于集合计划/产品中的
          <br />
          每个投资人穿透，只能根据公开信息一定程度局部穿透;其中理财子较
          <br />
          难以穿透，主要由于目前托管行及理财子较难分辨，因此该部分可能存
          <br />
          在错误，请各位投资人谨慎使用;
          <br />
          <br />
          【计算及示例】
          <br />
          举例1:光大证券资管-光大银行-光证资管诚享6号集合资产管理计划,
          <br />
          上述情况中根据部分公开资料了解，光大银行属于真实的持有人，光大
          <br />
          证券资管为受托机构，因此:
          <br />
          选择穿透:持有人-光大银行，类别-银行/银行理财子
          <br />
          不选择穿透:持有人-光大证券资管，类别-券商资管
          <br />
          <br />
          举例2:华金证券-东吴人寿保险股份有限公司-华金证券东吴人寿15号基
          <br />
          础设施基金策略FOF单-资产管理计划
          <br />
          选择穿透:持有人-东吴人寿保险股份有限公司，类别-保险;
          <br />
          不选择穿透:持有人-华金证券，类别-券商资管
        </div>
        <i class="el-icon-question" style="color: rgb(64, 158, 255)"></i>
      </el-tooltip>
    </div>
    <div
      v-if="select_4_default == '本期与上期对比'"
      class="reallocation-disclosure-note"
      role="note"
      aria-label="前十大投资者调仓计算口径">
      <i class="el-icon-info"></i>
      <span>
        <strong>前十大披露口径：</strong>
        相邻两期报告均存在时，投资者若仅在本期进入前十，上一期份额按 0
        计算增持；若仅在上一期出现，本期份额按 0 计算减持。未进入前十仅表示该期未被前十大名单披露，
        不代表其实际持仓必然为 0。
      </span>
    </div>
    <div class="chart-title">
      {{ title_name }}
    </div>
    <div
      style="width: 100%; height: 420px; margin-top: 10px"
      ref="chart_5425"
      v-loading="loading"
      element-loading-text="数据量巨大，正在计算中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 1)"></div>
    <div style="margin-top: 30px">
      <div
        v-if="select_4_default == '本期与上期对比' && show_cate == 'reit_code'"
        style="margin-bottom: 10px">
        <i class="el-icon-warning"></i>如果是本报告期新券，则下面的标题为蓝色
      </div>
      <el-table
        v-loading="loading"
        element-loading-text="数据量巨大，正在计算中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 1)"
        class="table1"
        :header-cell-style="tableStyle"
        :data="chart_data"
        max-height="700"
        style="width: 100%"
        :header-cell-class-name="isBlue">
        <el-table-column
          fixed
          prop="object_type"
          :width="gb === 'object_name' ? calcTabLabelMaxItemWidth(select3.default) : 180"
          label="类型"></el-table-column>
        <el-table-column
          min-width="150"
          fixed
          prop="object_name"
          v-if="gb === 'object_name'"
          label="前10大投资人"></el-table-column>
        <el-table-column
          :prop="k"
          :label="CODEobj[k] || k"
          :min-width="CODEobj[k] ? CODEobj[k].length * 20 + 95 : 130"
          sortable
          :sort-method="(a, b) => sortNumberWithEmpty(a, b, k)"
          v-for="k in tabKeys"
          :key="k"
          align="center">
          <!--  <template slot="header">
            <span :class="isBlue(k) ? 'bule' : ''">{{ CODEobj[k] || k }}</span>
          </template> -->
          <template slot-scope="scope">
            <div
              v-html="getDbhtml(scope.row, k)"
              v-if="
                select_4_default === '本期与上期对比' &&
                gb === 'object_name' &&
                show_cate == 'reit_code'
              "></div>
            <span v-else>
              {{
                scope.row[k]
                  ? select_2_default === '亿元' || select_2_default === '份额'
                    ? numberFix2N((scope.row[k] || 0) / 100000000) + '亿'
                    : number2Pct(scope.row[k] || 0)
                  : ''
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="sub" label="合计" min-width="130" sortable align="right">
          <template slot-scope="scope">
            {{
              scope.row.sub
                ? select_2_default === '亿元' || select_2_default === '份额'
                  ? numberFix2N((scope.row.sub || 0) / 100000000) + '亿'
                  : number2Pct(scope.row.sub || 0)
                : ''
            }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <ChartDialog
      :show.sync="show_chart_dialog"
      :echart_options="chart_options"
      :sty1="sty1"
      :sty2="sty2"
      :sty3="sty3" />
  </div>
</template>

<script>
import CCascader from '@/components/Basic/CCascader';
import CSelect from '@/components/Basic/CSelect';
import CButtons from '@/components/Basic/CButtons_separate.vue';
import Download from '@/components/Basic/Download.vue';
import ChartDialog from '../../Basic/ChartDialog.vue';

import { categroyDefaultValue, codesToNameMap2, debounce, number2Pct, numberFix2N } from '@/utils';

import { fnReturnTableStyle } from '@/utils/util';

export default {
  components: { CCascader, CSelect, CButtons, Download, ChartDialog },
  data() {
    const CATEGORYDATA = JSON.parse(localStorage.getItem('FINALLYCATEGORY')) || [];
    const da_lei_default_value = categroyDefaultValue(CATEGORYDATA);
    const REITsNAME = JSON.parse(localStorage.getItem('REITsNAME2')) || [];
    const CODEobj = JSON.parse(localStorage.getItem('CODEobj')) || {};
    return {
      chart_options: {},
      show_chart_dialog: false,
      loading: true,
      CODEobj: Object.freeze(CODEobj),
      range: 20,
      gb: 'object_type',
      show_cate: 'category_1',
      excel_info1: Object.freeze({
        overviewName: '',
        excel_data: [],
        json_fields: {},
      }),
      dButtonsDownloads: Object.freeze([
        {
          id: '241020',
          name: '下载图片',
        },
        {
          id: '241020',
          name: '下载表格',
        },
      ]),
      da_lei_default_value: ['公募REITs'],
      category_cascader_val_chart3: ['公募REITs'],
      category_cascader_options: Object.freeze(CATEGORYDATA),
      reit_code_default: [],
      CODENAMEDATA: Object.freeze(REITsNAME),
      reit_code: [],
      select_2: Object.freeze(['亿元', '份额', '绝对', '相对']),
      select_2_default: '亿元',
      select1: {
        default: 'all',
        options: [
          {
            label: '流通及非流通',
            value: 'all',
          },
          {
            label: '流通',
            value: 'float',
          },
          {
            label: '非流通',
            value: 'res',
          },
        ],
      },
      select3: {
        default: ['券商自营'],
        options: [
          {
            label: '券商自营',
            value: '券商自营',
          },
          {
            label: '券商资管',
            value: '券商资管',
          },
          {
            label: '信托',
            value: '信托',
          },
          {
            label: '私募基金',
            value: '私募基金',
          },
          {
            label: '产业资本',
            value: '产业资本',
          },
          {
            label: '不良资产管理',
            value: '不良资产管理',
          },
          {
            label: '公募基金及基金子公司',
            value: '公募基金及基金子公司',
          },
          {
            label: '国资投资公司',
            value: '国资投资公司',
          },
          {
            label: '银行/银行理财子',
            value: '银行/银行理财子',
          },
          {
            label: '保险',
            value: '保险',
          },
          {
            label: '原始权益人或关联方',
            value: '原始权益人或关联方',
          },
          {
            label: '个人',
            value: '个人',
          },
          {
            label: '其他类型',
            value: '其他类型',
          },
        ],
      },
      select11: {
        default: '',
        options: [],
      },
      chart_data: [],
      ROOTFONTFIZE: '',

      // 20250908

      del_new_code: false, //剔除新券
      del_gujiafuyin: false, //剔除期间基金单位价格浮盈/浮亏
      get_real_holder: false, //持有者穿透
      select_4: Object.freeze(['本期数据', '本期与上期对比']),
      select_4_default: '本期数据',
      select_2_2: Object.freeze(['亿元', '份额']),
      select_2_2_default: '亿元',
      title_name: '',
      new_codes: [],
    };
  },
  computed: {
    chart_title() {
      const show_cate = { category_1: '大类', category_2: '细分', reit_code: '个券' }[
        this.show_cate
      ];
      if (this.gb === 'object_type') {
        return `公募REITs - 不同板块${show_cate}投资人机构占比`;
      }
      const period = this.select11.default;
      return `${period}前${this.range}大投资人${show_cate}占比`;
    },
    tabKeys() {
      if (this.chart_data.length === 0) return [];
      const { sub, level_1, object_type, object_name, ...other } = this.chart_data[0];
      return Object.keys({ ...other });
    },
    queryStr() {
      const rp_period = this.select11.default;
      const r_type = this.category_cascader_val_chart3.join('&r_type=');
      const codes = this.reit_code.join('&codes=');
      const res_type = this.select1.default;
      const relative = { 份额: 3, 亿元: 2, 绝对: 0, 相对: 1 }[this.select_2_default];
      const gb = this.gb;
      const ob_sel = this.select3.default.join('&ob_sel=');
      const range = this.range;
      const show_cate = this.show_cate;
      const compare_mode = this.select_4_default == '本期与上期对比' ? 1 : 0;
      const del_new_code = this.del_new_code && this.select_4_default == '本期与上期对比' ? 1 : 0;
      const del_gujiafuyin =
        this.del_gujiafuyin && this.select_4_default == '本期与上期对比' ? 1 : 0;
      const get_real_holder = this.get_real_holder ? 1 : 0;
      if (gb === 'object_type') {
        return `rp_period=${rp_period}&res_type=${res_type}&relative=${relative}&gb=${gb}&show_cate=${show_cate}&codes=${
          codes || ''
        }&r_type=${
          r_type || ''
        }&range=${range}&ob_sel=&compare_mode=${compare_mode}&del_new_code=${del_new_code}&del_gujiafuyin=${del_gujiafuyin}&get_real_holder=${get_real_holder}`;
      }
      return `rp_period=${rp_period}&res_type=${res_type}&relative=${relative}&gb=${gb}&show_cate=${show_cate}&codes=${
        codes || ''
      }&r_type=${r_type || ''}&ob_sel=${
        ob_sel || ''
      }&range=${range}&compare_mode=${compare_mode}&del_new_code=${del_new_code}&del_gujiafuyin=${del_gujiafuyin}&get_real_holder=${get_real_holder}`;
    },
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
    tableStyle() {
      const val = this.$store.state.theme === 'dark';
      return () => fnReturnTableStyle(val);
    },
  },
  watch: {
    queryStr() {
      this.loading = true;
      this.debounceLoadingData();
    },
    currentTheme() {
      this.fnGetTheme();
      this.debounceRender();
    },
  },
  methods: {
    scopeColor(scopeKey) {
      let categoryName = scopeKey;
      if (this.show_cate === 'reit_code') {
        const codeItem = (this.$store.state.CODELIST || []).find(
          (item) => item.reitCode === scopeKey
        );
        categoryName =
          (codeItem && codeItem.reitsTypeL2) || this.map_l2[scopeKey] || scopeKey;
      }
      const liveColor = (this.$store.state.colors || []).find(
        (item) => item.name === categoryName
      );
      return (liveColor && liveColor.value) || this.category_colors[categoryName];
    },
    sortNumberWithEmpty(a, b, key) {
      const valA = a[key] === '' ? 0 : Number(a[key]);
      const valB = b[key] === '' ? 0 : Number(b[key]);
      return valA - valB;
    },
    sty1() {
      if (this.gb === 'object_name') return {};
      return {
        xAxis: { axisLabel: { rotate: 0 } },
      };
    },
    sty2() {
      if (this.gb === 'object_name') return {};
      return {
        xAxis: { axisLabel: { rotate: 270 } },
      };
    },
    sty3() {
      if (this.gb === 'object_name') return {};
      return {
        xAxis: { axisLabel: { rotate: 0 } },
      };
    },
    debounceLoadingData: debounce(function () {
      this.loadingData();
    }, 1000),
    calcTabLabelMaxItemWidth(keys) {
      return Math.max(...keys.map((k) => k.length)) * 20 + 10;
    },
    number2Pct,
    numberFix2N,
    async loadPeriod() {
      const { data } = await this.$https.get(`/api/v2_chopart/rp_period_button?r_type=`);
      if (data.code !== 200) return this.$message.error(data.msg);
      this.chart_data = Object.freeze(data.data);
      if (!(data.data || []).length) return;
      this.select11 = {
        default: data.data[0],
        options: data.data.map((item) => ({ label: item, value: item })),
      };
    },
    formatterColumn(row, column, cellValue, index) {
      return this.select_2_default === '亿元' || this.select_2_default === '份额'
        ? numberFix2N(cellValue)
        : number2Pct(cellValue);
    },
    debounceRender: debounce(function () {
      this.chartRender();
    }, 400),
    chartRender() {
      if (this.gb === 'object_type') {
        this.chartRender_1();
      } else if (this.gb === 'object_name') {
        this.chartRender_2();
      }
    },
    chartRender_1() {
      if (!this.chart_data.length) {
        return;
      }
      if (!this.echart_instance) {
        this.echart_instance = this.$echarts.init(this.$refs.chart_5425);
      }
      this.echart_instance.clear();

      let OPTIONDATA =
        this.$store.state.theme == 'dark'
          ? this.$store.state.OPTIONDATA
          : this.$store.state.OPTIONDATA_light;

      let data = this.chart_data;
      const xLabel = data.map((item) => item.object_type);
      const sub_data = data.map((item) => item.sub);

      const { object_type, sub, ...other } = data[0];
      data = Object.keys(other).map((k) => {
        return {
          index: k,
          ...data.reduce((p, c) => {
            p[c.object_type] = c[k] || 0;
            return p;
          }, {}),
        };
      });
      var series = data.map((item) => {
        const { index, ...args } = item;
        return {
          name: index,
          data: Object.values(args),
          type: 'bar',
          stack: 'stack',
          itemStyle: {
            color: this.scopeColor(index),
          },
        };
      });
      if (this.select_4_default === '本期与上期对比') {
        series.push({
          name: '净流入',
          data: sub_data,
          type: 'line',
          itemStyle: {
            color: 'red',
          },
        });
      }
      const options = {
        series,
        xAxis: {
          type: 'category',
          data: xLabel,
          axisLabel: {
            interval: 0,
            margin: OPTIONDATA.xAxis.axisLabel.margin,
            fontSize: OPTIONDATA.xAxis.axisLabel.fontSize,
            showMaxLabel: true,
            color: OPTIONDATA.xAxis.axisLabel.color,
            rotate: 0,
          },
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: (value) => {
              if (this.select_2_default === '亿元' || this.select_2_default === '份额') {
                return value / 100000000;
              }
              return numberFix2N(value * 100) + '%';
            },
            fontSize: OPTIONDATA.yAxis.axisLabel.fontSize,
            color: OPTIONDATA.yAxis.axisLabel.color,
          },
          splitLine: OPTIONDATA.yAxis.splitLine,
        },
        legend: {
          type: 'scroll',
          height: '85%',
          padding: [10, 0, 0, 0],
          itemWidth: 10,
          itemHeight: 10,
          right: 0,
          top: 'center',
          orient: 'vertical',
          pageIconColor: OPTIONDATA.legend.textStyle.color,
          pageTextStyle: { color: OPTIONDATA.legend.textStyle.color },
          textStyle: {
            color: OPTIONDATA.legend.textStyle.color,
            fontSize: this.ROOTFONTFIZE * (12 / 144),
          },
          formatter: (name) => {
            return this.CODEobj[name] || name;
          },
        },
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            const items = params
              .map(({ marker, seriesName, value }) => {
                const k = seriesName;
                const v =
                  this.select_2_default === '亿元' || this.select_2_default === '份额'
                    ? numberFix2N(value / 100000000) + '亿'
                    : number2Pct(value);
                return `<div>${marker} ${
                  this.show_cate === 'reit_code'
                    ? this.CODEobj[k]
                      ? this.CODEobj[k]
                      : '净流入'
                    : k
                }<span style="margin-left:10px">${v}</span></div>`;
              })
              .join('');
            return `${name}<br/>
              <div style="columns:${this.show_cate === 'reit_code' ? 3 : 1}">
              ${items}
              </div>
              `;
          },
        },
        toolbox: {
          // 工具箱按钮
          right: 30,
          top: -5,
          itemSize: 18,
          iconStyle: {
            borderColor: OPTIONDATA.toolbox.iconStyle.borderColor,
          },
          feature: {
            dataZoom: {}, // 区域缩放
          },
        },
        grid: {
          top: this.ROOTFONTFIZE * (20 / 144),
          left: this.ROOTFONTFIZE * (10 / 144),
          right: this.ROOTFONTFIZE * (150 / 144),
          bottom: this.ROOTFONTFIZE * (20 / 144),
          containLabel: true,
        },
      };

      this.echart_instance.setOption(options);
      this.echart_instance.resize();
      this.chart_options = Object.freeze(options);
      this.echart_instance.off('click');
      this.echart_instance.on('click', ({ name }) => {
        this.gb = 'object_name';
        this.select3 = {
          ...this.select3,
          default: [name],
        };
      });
    },
    chartRender_2() {
      if (!this.chart_data.length) {
        return;
      }
      if (!this.echart_instance) {
        this.echart_instance = this.$echarts.init(this.$refs.chart_5425);
      }
      this.echart_instance.clear();

      let OPTIONDATA =
        this.$store.state.theme == 'dark'
          ? this.$store.state.OPTIONDATA
          : this.$store.state.OPTIONDATA_light;

      const rows = this.chart_data;
      const xLabel = rows.map((item, index) => String(index));
      const { object_name, object_type, level_1, sub, ...other } = rows[0];
      const valueKeys = Object.keys(other);
      // Keep the API's materialized subtotal visible.  The bar series below
      // uses the exact same row order, so a duplicate display name cannot
      // overwrite another object type or make the line drift from the bars.
      const sub_data = rows.map((item) => Number(item.sub || 0));
      var series = valueKeys.map((key) => {
        return {
          name: key,
          data: rows.map((item) => Number(item[key] || 0)),
          type: 'bar',
          stack: 'stack',
          itemStyle: {
            color: this.scopeColor(key),
          },
        };
      });
      if (this.select_4_default === '本期与上期对比') {
        series.push({
          name: '净流入',
          data: sub_data,
          type: 'line',
          itemStyle: {
            color: 'red',
          },
        });
      }
      const options = {
        series,
        xAxis: {
          type: 'category',
          data: xLabel,
          axisLabel: {
            interval: 0,
            margin: OPTIONDATA.xAxis.axisLabel.margin,
            fontSize: OPTIONDATA.xAxis.axisLabel.fontSize * 0.8,
            showMaxLabel: true,
            color: OPTIONDATA.xAxis.axisLabel.color,
            rotate: 270,
            formatter: (value) => {
              const item = rows[Number(value)];
              return item ? item.object_name || '' : '';
            },
          },
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: (value) => {
              return this.select_2_default === '亿元' || this.select_2_default === '份额'
                ? value / 100000000
                : numberFix2N(value * 100) + '%';
            },
            fontSize: OPTIONDATA.yAxis.axisLabel.fontSize,
            color: OPTIONDATA.yAxis.axisLabel.color,
          },
          splitLine: OPTIONDATA.yAxis.splitLine,
        },
        legend: {
          type: 'scroll',
          height: '85%',
          padding: [10, 0, 0, 0],
          itemWidth: 10,
          itemHeight: 10,
          right: 0,
          top: 'center',
          orient: 'vertical',
          pageIconColor: OPTIONDATA.legend.textStyle.color,
          pageTextStyle: { color: OPTIONDATA.legend.textStyle.color },
          textStyle: {
            color: OPTIONDATA.legend.textStyle.color,
            fontSize: this.ROOTFONTFIZE * (10 / 144),
          },
          formatter: (name) => {
            return this.CODEobj[name] || name;
          },
        },
        toolbox: {
          // 工具箱按钮
          right: 30,
          top: -5,
          itemSize: 18,
          iconStyle: {
            borderColor: OPTIONDATA.toolbox.iconStyle.borderColor,
          },
          feature: {
            dataZoom: {}, // 区域缩放
          },
        },
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            const rowIndex = Number(params[0].axisValue);
            const row = rows[rowIndex] || {};
            const name = row.object_name || '';
            const items = params
              .map(({ marker, seriesName, value }) => {
                const k = seriesName;
                const v =
                  this.select_2_default === '亿元' || this.select_2_default === '份额'
                    ? numberFix2N(value / 100000000) + '亿'
                    : number2Pct(value);
                if (v === '0.00亿' || v === '0.00%') return;
                return `<div>${marker} ${
                  this.show_cate === 'reit_code'
                    ? this.CODEobj[k]
                      ? this.CODEobj[k]
                      : '净流入'
                    : k
                }<span style="margin-left:10px">${v}</span></div>`;
              })
              .filter((t) => t)
              .join('');
            return `${name}<br/>
              <span style="opacity:0.75">${row.object_type || ''}</span><br/>
              <div style="columns:${this.show_cate === 'reit_code' ? 3 : 1}">
              ${items}
              </div>
              `;
          },
        },
        grid: {
          top: this.ROOTFONTFIZE * (20 / 144),
          left: this.ROOTFONTFIZE * (10 / 144),
          right: this.ROOTFONTFIZE * (150 / 144),
          bottom: this.ROOTFONTFIZE * (20 / 144),
          containLabel: true,
        },
      };
      this.echart_instance.off('click');
      this.echart_instance.setOption(options);
      this.echart_instance.resize();
      this.chart_options = Object.freeze(options);
    },
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;
    },
    resize() {
      this.fnGetWidth();
      this.echart_instance && this.echart_instance.resize();
    },
    fnGetTheme() {
      this.sCurrentTheme = this.$store.state.theme == 'dark' ? true : false;
    },
    select2Change(v) {
      this.select_2_default = v;
      if (this.select_2_default != '亿元' && this.select_2_default != '份额') {
        this.select_2_2_default = '亿元';
        return;
      }
      this.select_2_2_default = this.select_2_default;
    },
    fnCCascader_select_val_chart3(val) {
      if (!val.length) {
        this.$message.error('请选择类别');
        return;
      }
      this.category_cascader_val_chart3 = val;
    },
    fnSelect_select_val_chart1_codename(val) {
      val = val.filter((node) => {
        return node.includes('.');
      });

      this.reit_code = Object.freeze(val);
    },
    fnCSelect_chart1(v) {
      this.select1 = {
        ...this.select1,
        default: v,
      };
    },
    fnCSelect_chart11(v) {
      this.select11 = {
        ...this.select11,
        default: v,
      };
    },
    fnCSelect_chart3(v) {
      this.select3 = {
        ...this.select3,
        default: v,
      };
    },
    async loadingData() {
      let data;
      try {
        ({ data } = await this.$https.get(
          `/api/v2_chopart/fin_investor_holder_compare?${this.queryStr}`
        ));
      } catch (error) {
        const payload = (error.response && error.response.data) || {};
        this.chart_data = Object.freeze([]);
        this.echart_instance && this.echart_instance.clear();
        this.$message.warning(payload.msg || '投资者结构接口请求失败');
        return;
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 300);
      }
      this.title_name = data.title_name;
      if (data.code !== 200) {
        return this.$message.error(data.msg);
      }
      this.db = Object.freeze(data.db);
      this.new_codes = data.new_codes || [];
      this.chart_data = Object.freeze(data.data);
      if (!(data.data || []).length) {
        this.echart_instance && this.echart_instance.clear();
        return;
      }
      console.log('chart_data', this.chart_data);
      if (this.show_cate === 'reit_code') {
        const json_fields = Object.keys(data.data[0]).reduce((p, c) => {
          if (this.CODEobj[c]) {
            p[this.CODEobj[c]] = {
              callback: (v) => {
                return v[c];
              },
            };
          } else {
            p[c] = c;
          }
          return p;
        }, {});
        const item = { ...data.data[0] };
        Object.keys(item).forEach((k) => {
          if (k === 'object_type') {
            item[k] = '代码';
          } else if (k === 'sub') {
            item[k] = '';
          } else {
            item[k] = k;
          }
        });
        const _data = [item, ...data.data];
        this.excel_info1 = Object.freeze({
          excel_data: _data,
          overviewName: this.chart_title,
          json_fields,
        });
      } else {
        const json_fields = Object.keys(data.data[0]).reduce((p, c) => {
          p[c] = c;
          return p;
        }, {});
        this.excel_info1 = Object.freeze({
          excel_data: data.data,
          overviewName: this.chart_title,
          json_fields,
        });
      }

      setTimeout(() => {
        this.debounceRender();
      }, 0);
    },
    //20250908
    select4Change(v) {
      this.select_4_default = v;
      if (
        this.select_4_default == '本期与上期对比' &&
        this.select_2_2_default != '亿元' &&
        this.select_2_2_default != '份额'
      ) {
        this.select_2_2_default = '亿元';
      } else {
        this.select_2_default = this.select_2_2_default;
      }
    },
    getDbhtml(row, k) {
      var str = '';
      if (!this.db) {
        return;
      }
      this.db.forEach((item) => {
        if (item.index == row.object_name) {
          str = item[k];
        }
      });

      if (!str) {
        return row[k]
          ? this.select_2_default === '亿元' || this.select_2_default === '份额'
            ? numberFix2N((row[k] || 0) / 100000000) + '亿'
            : number2Pct(row[k] || 0)
          : '';
      }
      var type = 1; //1为新晋，0为出榜
      if (str.indexOf('出榜') != -1) {
        type = 0;
      }
      const str_list = str
        .replace(' ', '')
        .split('<br/>')
        .filter((item) => item != ' ' || item != undefined);
      var res = '';
      res += '<div>';
      res += row[k]
        ? this.select_2_default === '亿元' || this.select_2_default === '份额'
          ? numberFix2N((row[k] || 0) / 100000000) + '亿'
          : number2Pct(row[k] || 0)
        : '';
      res += '</div>';
      if (type) {
        res += "<div class='str_case'><div class='str_title xj'>新晋</div><div class='str_c'>";
        str_list.forEach((item) => {
          res += item.replace('新晋', '') + '<br/>';
        });
        res += '</div></div>';
        return res;
      }
      res += "<div class='str_case '><div class='str_title cb'>出榜</div><div class='str_c'>";
      str_list.forEach((item) => {
        res += item.replace('出榜', '') + '<br/>';
      });
      res += '</div></div>';
      return res;
    },
    isBlue({ column }) {
      const property = column.property;
      if (this.select_4_default == '本期与上期对比' && this.show_cate == 'reit_code') {
        if (this.new_codes.indexOf(property) != -1) {
          return 'bule';
        }
      }
      return '';
    },
  },
  async created() {
    await this.loadPeriod();
    /*     this.reit_code = Object.freeze(
      this.reit_code_default
        .map((item) => {
          return item.find((n) => n.indexOf('.') >= 0);
        })
        .filter((item) => item)
    ); */
    const colors = this.$store.state.colors || [];
    this.category_colors = colors.reduce((p, c) => {
      p[c.name] = c.value;
      return p;
    }, {});
    this.map_l2 = JSON.parse(localStorage.getItem('MAP_L2') || '[]').reduce((p, c) => {
      p[c.name] = c.value;
      return p;
    });
  },
  mounted() {
    this.resize();
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
    this.echart_instance && this.echart_instance.dispose();
  },
};
</script>

<style scoped lang="less">
.hidden {
  visibility: hidden;
}

.icon-fangda {
  position: absolute;
  right: 8px;
  top: 190px;
}

/deep/.el-radio__input.is-checked + .el-radio__label {
  color: var(--chart_title);
}
/deep/.el-radio__label {
  color: var(--chart_title);
  font-weight: 400;
}
/deep/.el-radio {
  margin-right: 16px;
}

.input-range {
  box-sizing: border-box;
  border-radius: 3px;
  width: 70px;
  height: 35px;
  padding: 6px;
  margin-left: 6px;
  text-align: center;
  color: var(--Select-color2);
  border: none;
  outline: none;
  background-color: var(--Btn-bgc);
}

.chart-title {
  margin-top: 16px;
  color: var(--chart_title);
  font-weight: 700;
  font-size: 16px;
  text-align: center;
}

.reallocation-disclosure-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 14px;
  padding: 10px 12px;
  border-left: 3px solid #409eff;
  border-radius: 3px;
  color: var(--legndAreaItem_color);
  background-color: var(--Btn-bgc);
  font-size: calc(var(--ROOTFONTFIZE) * (13 / 144));
  line-height: 1.7;

  .el-icon-info {
    margin-top: 4px;
    color: #409eff;
    flex: 0 0 auto;
  }
}

//fix 滚动条重叠部分背景颜色
/deep/.el-table__body-wrapper::-webkit-scrollbar-corner {
  background-color: transparent;
}
/deep/.items-center {
  align-items: center;
}
/deep/.relative {
  position: relative;
}
/deep/.flex {
  display: flex;
}

/* el-table start */

::v-deep .table1 table {
  border: none;
}

::v-deep .el-table__body .el-table__row .el-table__cell {
  background-color: var(--table_bgc);
  color: var(--table_color);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  height: calc(var(--ROOTFONTFIZE) * (60 / 144));
  border-bottom: calc(var(--ROOTFONTFIZE) * (1 / 144)) solid var(--table_brc);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: var(--table_bgc_hover);
  /* background-color: var(--table_color_hover); */
  color: var(--table_color_hover);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell:hover {
  cursor: pointer;
}

::v-deep .el-table::before {
  background-color: var(--table_bgc);
}

::v-deep .el-table {
  border-bottom: none !important;
  background-color: var(--table_bgc);
}

/* el-table end */

.oneyear {
  margin-left: 30px;
  color: var(--legndAreaItem_color);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  /deep/.el-checkbox {
    margin-left: 0px !important;
  }
}
/deep/ .el-table .str_case {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  // align-items: center;
  font-size: calc(var(--ROOTFONTFIZE) * (10 / 144));
  line-height: calc(var(--ROOTFONTFIZE) * (25 / 144));
  .str_title {
    padding: 0px 10px;
    color: #fff;
    height: calc(var(--ROOTFONTFIZE) * (25 / 144));
  }
  .xj {
    background-color: #e97132;
  }
  .cb {
    background-color: #0f9ed5;
  }
  .str_c {
    padding-left: 5px;
    // flex: 1;
    text-align: left;
  }
}

/deep/ .el-table .el-table__fixed::before {
  background-color: transparent !important;
}
/deep/ .el-table .bule {
  color: #0f9ed5 !important;
}
</style>
